import { withTheme } from 'theme';
import material3 from 'theme/material3';

const container = withTheme(() => ({
  width: '100%'
}));

const titleWrapper = withTheme((theme) => ({
  width: '100%',
  padding: theme.spacing(1.5, 2),
  background: material3.color.primaryLight,
  borderRadius: material3.shape.large,
  marginBottom: theme.spacing(1),
  maxWidth: '600px',
  '& .MuiTypography-root': {
    color: material3.color.primaryDark
  }
}));

const styles = {
  container,
  titleWrapper
};

export default styles;
